import { IMainContextProvider } from './MainContext.types';
import { useViewport } from 'hooks/ViewportHook';
import { MainContext } from './MainContext';

export const MainContextProvider = (props: IMainContextProvider) => {
    const { children } = props;
    const viewPort = useViewport();

    return <MainContext.Provider value={viewPort}>{children}</MainContext.Provider>;
};
